<template>
  <div class="container-fluid">
    <div class="row flex-md-row flex-column">
      <div class="col-md-4 col-12 custom-col-md-4 d-flex align-items-center">
        <div id="myCarousel" class="carousel slide" data-ride="carousel" v-if="images.length > 1">
          <ol class="carousel-indicators">
            <li
              v-for="(image, index) in images"
              :key="index"
              :data-target="'#myCarousel'"
              :data-slide-to="index"
              :class="{ active: index === 0 }"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              v-for="(image, index) in images"
              :key="index"
              :class="['carousel-item', { active: index === 0 }]"
            >
              <img :src="image" alt="Image" class="d-block w-100" style="object-fit: cover;" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div v-else>
          <img :src="images[0]" alt="Image" class="d-block w-100" style="object-fit: cover;" />
        </div>
      </div>
      <div class="col-md-6 col-12 custom-col-md-6">
        <h4>{{ title }}</h4><br />
        <p class="text-dark-gray" v-html="description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require('@/assets/images/news/07/news_02.jpg'),
        //可輪播圖片
        //EX:require('@/assets/images/news/01/news_3.png'),
      ],
      //標題
      title: '【 TSK | 台灣醫用雷射光電學會-秋季學術研討會 】',
      //內文
      description:
        '<b>TSK 將參與 2024台灣醫用雷射光電學會-秋季學術研討會！</b><br><br>TSK醫美尖針與鈍針，融合日本製造的高品質與工匠精神，為醫美行業帶來安全、精準且舒適的使用體驗。展會現場將展示多款TSK針頭的型號規格，歡迎親臨攤位體驗TSK針頭的卓越手感。<br><br><b>🌟 好康加碼 1 🌟</b><br> 當天蒞臨TSK攤位，完成蓋章集點活動與指定條件，即可參與由“台灣醫用雷射光電學會”舉辦的「iPhone 16 與 TSK尖針鈍針 抽獎活動」！<br><br><b>🌟 好康加碼 2 🌟</b><br> 歡迎至TSK現場攤位參與「展會限定-幸運轉轉盤活動」贏取更多專屬優惠！<br>驚喜獎品包含產品折扣、贈品組合等多重優惠，祝您轉出好運，帶回驚喜！ <br><br>現場更多優惠與活動等您來發現，不要錯過⮕<br>展會時間：2024年10月27日(日)<br> 展會地點：華南銀行國際會議中心<br> 攤位編號：9',
    };
  },
};
</script>

<style scoped>
.custom-col-md-4 {
  flex: 0 0 auto;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-col-md-6 {
  flex: 0 0 auto;
  width: 60%;
}
@media (max-width: 767.98px) {
  .custom-col-md-4,
  .custom-col-md-6 {
    flex: 0 0 auto;
    width: 100%;
  }
}
</style>
